import React from 'react';
import Grid from '@material-ui/core/Grid';
import { COLORS } from '../../../styles/constants';
import { useSelector } from 'react-redux';
import { useTableCellStyles } from './styles';
import clsx from 'clsx';

const SelectedValuesCardInRow = () => {
	const inputParameters = useSelector(state => state.wdValidator.inputParameters);
	const tableCellClasses = useTableCellStyles();

	return (
		<Grid
			style={{
				backgroundColor: 'white',
				paddingLeft: '10px',
				paddingRight: '16px',
				marginRight: '4px',
				fontSize: '13px'
			}}>
			WebDesigner+ Power Supply Recommended List
			<span>{' ('}for values: </span>
			Input Supply Type
			{' =' + '\u00a0'}
			<span className={clsx(tableCellClasses.values)}>{inputParameters.supplyType}</span>
			{',' + '\u00a0' + '\u00a0'}
			{inputParameters.supplyType === 'DC' ? (
				<>
					{' '}
					V
					<sub>
						IN<sub>DC</sub> (max){' '}
					</sub>
					{'=' + '\u00a0'}{' '}
				</>
			) : (
				<>
					{' '}
					V
					<sub>
						IN<sub>RMS</sub> (max){' '}
					</sub>
					{'=' + '\u00a0'}{' '}
				</>
			)}
			<span className={clsx(tableCellClasses.values)}> {inputParameters.vinMax}</span> V{',' + '\u00a0' + '\u00a0'}
			{inputParameters.supplyType === 'DC' ? (
				<>
					V
					<sub>
						IN<sub>DC</sub> (min){' '}
					</sub>
					{'=' + '\u00a0'}
				</>
			) : (
				<>
					V
					<sub>
						IN<sub>RMS</sub> (min){' '}
					</sub>
					{'=' + '\u00a0'}
				</>
			)}
			<span className={clsx(tableCellClasses.values)}> {inputParameters.vinMin}</span> V{',' + '\u00a0' + '\u00a0'}V
			<sub>OUT </sub>
			{'=' + '\u00a0'}
			<span className={clsx(tableCellClasses.values)}> {inputParameters.vout}</span> V{',' + '\u00a0' + '\u00a0'}I
			<sub>OUT </sub>
			{'=' + '\u00a0'}
			<span className={clsx(tableCellClasses.values)}>{inputParameters.iout}</span> A{',' + '\u00a0' + '\u00a0'}T
			<sub>a </sub>
			{'=' + '\u00a0'}
			<span className={clsx(tableCellClasses.values)}> {inputParameters.ambientTemperature}</span>
			{'\u00a0'}
			&deg;C
			{inputParameters.supplyType === 'DC' ? (
				<span></span>
			) : (
				<span>
					{',' + '\u00a0' + '\u00a0'}
					Frequency
					{' =' + '\u00a0'} <span className={clsx(tableCellClasses.values)}>{inputParameters.lineFrequency}</span>
					<span
						style={{
							color: COLORS.TEXT_SECONDARY
						}}>
						{'\u00a0'}Hz
					</span>
				</span>
			)}
			{')'}
		</Grid>
	);
};

export default SelectedValuesCardInRow;
